import React from 'react';
import { Flow } from 'flow-react';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import Modal from 'components/UI/Modal/Modal';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as ConfigTypes from 'config/ConfigTypes';
import WishList from "components/Cart/WishList/WishList";
import CartList from "components/Cart/CartList/CartList";
import RentalList from "components/Cart/RentalList/RentalList";
import RentEdit from "pages/CartPage/RentEdit/RentEdit";

import './CartMainPage.scss'

const CartMainPage = observer(
    class CartMainPage extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                modalOpened: false,
                formErrors: {},
            }
        }

        initData = (prevProps) => {
            const { shopForm } = this.props.cartObjects;
            if (prevProps.cartObjects.shopForm != shopForm) {
                //this.setState({ modalOpened: true, shopForm: shopForm });
                this.setState({ modalOpened: shopForm, shopForm: shopForm });
            }
        }

        closeModal = () => {
            this.setState({ modalOpened: false, shopForm: null });
            this.props.updateCartObjects({ shopForm: null });
        }

        showForm = () => {
            switch (this.state.shopForm) {
                case ConfigTypes.WISHLIST:
                    return (<WishList onCloseModal={this.closeModal} />)
                case ConfigTypes.CART:
                    return (<CartList onCloseModal={this.closeModal} />)
                case ConfigTypes.RENTALLIST:
                    return (<RentalList onCloseModal={this.closeModal} />)
                case ConfigTypes.RENT_EDIT:
                    return (<RentEdit onCloseModal={this.closeModal} />)
                default:
                    return;
            }
        }

        componentDidUpdate(prev) {
            this.initData(prev);
        }

        componentDidMount() {
            const { shopForm } = this.props.cartObjects;
            if (shopForm) {
                this.setState({ modalOpened: true, shopForm: shopForm });
            }
            // console.log("LOGS: LAMTEST CartMainPage");
            // this.props.getCart();
        }

        render() {
            return (
                <div className="cartmainpage">
                    {this.state.shopForm && this.showForm()}
                </div>)
        }
    }
)

const mapStateToProps = (state) => ({
    cartObjects: state.cart.cartObjects,
    configObjects: state.config.configObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
    getCart: () => dispatch(actions.getCart())
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(CartMainPage))));


